import React from "react";

function Pre({ loading }) {
  return <div id={loading ? "preloader" : "preloader-none"} />;
}

export default Pre;
